import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
//syncing to local storage to avoid affecting other parts of the app.
export const useUserStore = defineStore(
    'user',
    () => {
        // State
        const user = ref(null);

        // Getters
        const getUser = computed(() => user.value);
        const selectedTenant = computed(() => user.value?.selectedTenant);
        const isAuthenticated = computed(() => !!user.value);
        const userRoles = computed(() => user.value?.roles.map(role => role.name) || []);
        const userPermissions = computed(() => user.value?.rolepermissions.map(perm => perm.name) || []);

        // Actions
        function setUser(userData) {
            user.value = userData;
            // saveToLocalStorage();
        }
        function getTenant(tenantId) {
            return user.value?.tenants.find(tenant => tenant.Id === tenantId);
        }

        function setTenants(tenants) {
            user.value.tenants = tenants;
        }

        function clearUser() {
            user.value = null;
            // removeFromLocalStorage();
        }

        function loadFromLocalStorage() {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                user.value = JSON.parse(storedUser);
            }
        }

        function saveToLocalStorage() {
            if (user.value) {
                localStorage.setItem('user', JSON.stringify(user.value));
            }
        }

        function removeFromLocalStorage() {
            localStorage.removeItem('user');
        }

        // Initialize store from localStorage
        loadFromLocalStorage();

        return {
            user,
            getUser,
            getTenant,
            setTenants,
            selectedTenant,
            isAuthenticated,
            userRoles,
            userPermissions,
            setUser,
            clearUser,
            loadFromLocalStorage,
        };
    },
    {
        persist: false,
        // Pinia persist option to ensure localStorage sync
        // requires pinia-plugin-persistedstate
        // persist: {
        //   storage: localStorage,
        //   paths: ['user'],
        // },
    },
);
